import { createComponent } from 'js/lib/create-component'
import { loadScript } from 'js/lib/script-loader'
import { Observable, waitForNextResult } from 'js/lib/observable'

const SITE_KEY = '6LfrahgUAAAAAB2laLcMskqOYf4D-ZhQtVSgi7Ul'

let recaptchaIsLoaded
const recaptchaObservable = new Observable()

// We're not actually using alpine for anything but initializing recaptcha. The sate object returned
// doesn't actually do anything.
createComponent('recaptcha', function () {
  function init() {
    initializeRecaptcha(this)
  }

  return {
    recaptcha: true,
    init,
  }
})

async function initializeRecaptcha(component) {
  recaptchaIsLoaded = new Promise(resolve => {
    window.onRecaptchaLoad = resolve
    loadScript('https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit')
  })

  await recaptchaIsLoaded
  grecaptcha.render(component.$refs.recaptchaContainer, {
    sitekey: SITE_KEY,
    size: 'invisible',
    callback: response => recaptchaObservable.emit.event(response),
    'expired-callback': () => recaptchaObservable.emit.error('expired'),
    'error-callback': () => recaptchaObservable.emit.error('error'),
  })
}

export async function getRecaptchaResult() {
  if (!recaptchaIsLoaded) throw new Error('Recaptcha isnt loaded yet')
  try {
    await recaptchaIsLoaded
    grecaptcha.reset()
    grecaptcha.execute()
    const result = await waitForNextResult(recaptchaObservable)
    return result
  } catch (error) {
    if (error === 'expired') {
      $.petrescue.flash('notice', 'Recaptcha expired - please try again')
    } else {
      $.petrescue.flash('notice', 'Recaptcha error - please refresh the page and try again')
    }
  }
}
